import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Button, Drawer } from 'antd';
import { MenuOutlined } from '@ant-design/icons';
import { APP_NAME } from '../../common/constants';
import Logo from '../../assets/logo-tigoon.png';
import './Header.css';

const Header = () => {
    const location = useLocation();
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const menuItems = [
        { key: '/', label: <Link to="/">Accueil</Link> },
        { key: '/features', label: <Link to="/features">Fonctionnalités</Link> },
        { key: '/avantages', label: <Link to="/avantages">Avantages</Link> },
        { key: '/affilies', label: <Link to="/affilies">Affilies</Link> },
        { key: '/ambassadeurs', label: <Link to="/ambassadeurs">Brand Ambassador</Link> },
        { key: '/chauffeurs/classement', label: <Link to="/chauffeurs/classement">Classement</Link> },
        { key: '/about', label: <Link to="/about">A propos</Link> },
        { key: '/contact', label: <Link to="/contact">Contact</Link> },
    ];

    return (
        <header className="header">
            <div className="header-container">
                <Link to="/" className="logo">
                    <img src={Logo} alt={APP_NAME} className="logo-image" />
                </Link>

                {/* Desktop Menu */}
                <nav className="nav-desktop">
                    <Menu
                        mode="horizontal"
                        selectedKeys={[location.pathname]}
                        items={menuItems}
                        className="nav-menu"
                        overflowedIndicator={null}
                        disabledOverflow={true}
                    />
                </nav>

                {/* Mobile Menu Button */}
                <Button
                    className="mobile-menu-btn"
                    type="text"
                    icon={<MenuOutlined />}
                    onClick={() => setMobileMenuOpen(true)}
                />

                {/* Mobile Drawer */}
                <Drawer
                    title={APP_NAME}
                    placement="right"
                    onClose={() => setMobileMenuOpen(false)}
                    open={mobileMenuOpen}
                    className="mobile-drawer"
                >
                    <Menu
                        mode="vertical"
                        selectedKeys={[location.pathname]}
                        items={menuItems}
                        onClick={() => setMobileMenuOpen(false)}
                    />
                </Drawer>
            </div>
        </header>
    );
};

export default Header;
